import { compact, isArray, isString } from 'lodash';
import { checkoutTileMap } from '@/views/checkout/constant';
import EventTracking from '@/aspects/trackings';
import { enableErrorMessageTrackingInOPC } from '@/common/constants';

const TRACKING_JOINER = ' - ';

function trimStringList(stringList) {
  if (isArray(stringList)) {
    return compact(
      stringList.map((item) => {
        return isString(item) ? item.trim() : item;
      }),
    );
  } else {
    return compact(stringList);
  }
}

export const TRACKING_CONSTANT = {
  CYCLE_TOGGLE_BILLED: (billingCycle) => `toggled billed ${billingCycle}`.toLowerCase(),
  LICENSE_CHANGE: (billingCycle, newLicese, oldLicense) =>
    trimStringList([billingCycle, newLicese > oldLicense ? 'increase' : 'decrease', newLicese]).join(TRACKING_JOINER),
  IMPRESSION: (...info) => trimStringList([...info, 'impression']).join(TRACKING_JOINER),
  CLOSE: (...info) => trimStringList([...info, 'close']).join(TRACKING_JOINER),
  CHECKBOX: (isChecked, ...info) => trimStringList([...info, isChecked ? 'check' : 'uncheck']).join(TRACKING_JOINER),
  join: (...info) => trimStringList(info).join(TRACKING_JOINER),
};

export const sendFormValidationErrors = (fields= [], checkoutTile)=>{
  if(!enableErrorMessageTrackingInOPC){
    return
  }
  const fieldStr = Array.isArray(fields) ? fields.join('|') : ''
  let moduleName = ''
  switch(checkoutTile){
    case checkoutTileMap.signUp:
      moduleName = 'sign up'
      break
    case checkoutTileMap.address:
      moduleName = 'address'
      break
    case checkoutTileMap.useVerification:
      moduleName='user verification'
      break
  }
  if(fieldStr){
    EventTracking.formValidationError(`form error - ${moduleName} - ${fieldStr}`)
  }
}
